export default {"src":"/_next/static/media/logo-dark-small.74650b40.svg","height":57,"width":49,"blurWidth":0,"blurHeight":0};